module.exports = __webpack_public_path__ + "images/62712c9e69ba7eb4e8e94473d7d5c4b5-adventure_xpo.png";